<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="bCardQueja" v-if="vistaFiltrado == false">
      <p class="sub-detalle">En <span class="bold-blue">Dentalia</span> nos preocupamos por la satisfacción de nuestros pacientes. Si un paciente se acerca a ti con una queja o inquietud acerca de nuestro servicio, por favor, escucha atentamente y
        toma nota de todos los detalles. Tu colaboración es crucial para que podamos mejorar y ofrecer una atención de calidad. Recuerda que en Dentalia nos importa el bienestar de nuestros
        pacientes, y estamos comprometidos a brindar la mejor atención posible. Gracias por tu compromiso y dedicación en tu labor como colaborador.
      </p>
      <b-tabs v-model="tabIndex"  >
        <b-tab title="Generar solicitud" active >
          <div class="container-fluid mt-0">
            <b-row class>
              <b-col md="8" sm="12" >
                <b-row>
                  <b-col md="6" sm="12">
                    <b-form-group align="left">
                      <label for="clinica">Clínica:<validacion/></label>
                      <v-select
                          id="clinica"
                          name="clinica"
                          placeholder="Clinica"
                          label="strNombre"
                          :options="clinicas"
                          :reduce="(i) => i.idClinica"
                          v-model="$v.solicitud.idClinica.$model"
                          :state="validateState('idClinica')"
                          :class="selectClass('idClinica')"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group align="left">
                      <label for="origen"
                      >Origen de incidencia:
                        <validacion/>
                      </label>
                      <v-select
                          id="origen"
                          name="origen"
                          placeholder="Origen de incidencia"
                          label="descripcion"
                          :options="origenes"
                          :reduce="(i) => i.id"
                          v-model="$v.solicitud.idOrigen.$model"
                          :state="validateState('idOrigen')"
                          :class="selectClass('idOrigen')"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group align="left">
                      <label for="clasificacion"
                      >Tipo de solicitud:
                        <validacion/>
                      </label>

                      <v-select
                          id="clasificacion"
                          name="clasificacion"
                          placeholder="Tipo de solicitud"
                          label="descripcion"
                          :options="tipoQuejas"
                          :reduce="(i) => i.id"
                          v-model="solicitud.tipoQueja"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                  <b-col  v-if="solicitud.tipoQueja !== null && solicitud.tipoQueja !== 2">
                    <b-form-group align="left">
                      <label for="especialidad"
                      >Especialidad:
                        <validacion/>
                      </label>
                      <v-select
                          id="especialidad"
                          name="especialidad"
                          placeholder="Especialidad"
                          label="text"
                          :options="especialidades"
                          :reduce="(i) => i.value"
                          v-model="$v.solicitud.especialidad.$model"
                          :state="validateState('especialidad')"
                          :class="selectClass('especialidad')"
                      ></v-select>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group align="left">
                      <label for="clasificacion"
                      >Motivo de solicitud:
                        <validacion/>
                      </label>
                      <v-select
                          id="clasificacion"
                          name="clasificacion"
                          placeholder="Motivo de solicitud"
                          label="description"
                          :options="clasificaciones"
                          :reduce="(i) => i.idClasificacion"
                          v-model="$v.solicitud.idClasificacion.$model"
                          :state="validateState('idClasificacion')"
                          :class="selectClass('idClasificacion')"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                    v-if="solicitud.idOrigen === 4"
                >
                  <b-col>
                    <b-form-group align="left">
                      <label for="Calificacion"
                      >Calificación
                        <validacion/>
                      </label>
                      <v-select
                          id="Calificacion"
                          name="Calificacion"
                          placeholder="Calificación"
                          :options="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                          v-model="$v.solicitud.calificacion.$model"
                          :state="validateState('calificacion')"
                          :class="selectClass('calificacion')"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group align="left">
                      <label for="url">Descripción de la incidencia: <validacion/></label>
                      <b-input-group size="sm" class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="card-text"></b-icon>
                        </b-input-group-prepend>
                        <b-form-textarea
                            id="url"
                            name="url"
                            placeholder="Incidencia  "
                            type="text"
                            v-model="$v.solicitud.descripcion.$model"
                            :state="validateState('descripcion')"
                        ></b-form-textarea>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <ContactoPaciente
                    :idPaciente="solicitud.idPaciente"
                    @_setearValor="setearValor"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col class="text-center">
                <b-button
                    class="button-dentalia"
                    variant="outline-primary"
                    :disabled="loaderGuardar"
                    @click="guardar()"
                >
                  <span v-if="!loaderGuardar">Guardar</span>
                  <span v-if="loaderGuardar">
                  <b-spinner small></b-spinner>
                  Cargando...
                </span>
                </b-button>
              </b-col>

            </b-row>
          </div>
        </b-tab>
        <b-tab
            title="Historial de solicitudes"
        >
          <historial-quejas-paciente :key="actualizarHistorial"/>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import {GarantiaService} from "../../../apiServices/garantias/GarantiaService";
import {CatalogosService} from "../../../apiServices/catalogos/CatalogosService";
import {TickeService} from "../../../apiServices/garantias/tickeService";
import {required} from "vuelidate/lib/validators";
import ContactoPaciente from "../../../components/paciente/ContactoPaciente";
import HistorialQuejasPaciente from "../GaratiasRAS/HistorialQuejasPaciente.vue";

export default {
  name: "QuejasPaciente",
  components: {ContactoPaciente, HistorialQuejasPaciente},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      garantiaServicio: new GarantiaService(),
      catalogoServicio: new CatalogosService(),
      ticketServicio: new TickeService(),
      clinicas: [],
      origenes: [],
      tipoQuejas: [],
      clasificaciones: [],
      drivers: [],
      temas: [],
      subtemas: [],
      especialidades: [
        {value: 1, text: "Endodoncia"},
        {value: 2, text: "Periodoncia/Cirugía"},
        {value: 3, text: "Prótesis/OG"},
      ],

      paciente: null,
      listaBusquedaPaciente: [],

      loaderGuardar: false,
      tabIndex: 0,

      solicitud: {
        idPaciente: null,
        idClinica: null,
        idOrigen: null,
        calificacion: null,
        especialidad: null,
        idClasificacion: null,
        descripcion: null,
        driver: null,
        tema: null,
        subtema: null,
        tipoQueja: null,
      },
      contactoSeleccionado: null,
      modalContacto: false,
      actualizarHistorial: false,
    };
  },
  validations() {

    let datos;
    datos = {
      solicitud: {
        idPaciente: {required},
        idClinica: {required},
        idOrigen: {required},
        calificacion: {},
        especialidad: {},
        idClasificacion: {required},
        descripcion: {required},
      }
    }

    if (this.solicitud.tipoQueja !== null && this.solicitud.tipoQueja !== 2) {
      datos.solicitud.especialidad = {required}
    }

    if (this.solicitud.idOrigen === 4) {
      datos.solicitud.calificacion = {required}
    }

    return datos;
  },
  props: {
    idPaciente: Number,
    nombreCompleto: String,
    vistaFiltrado: Boolean,
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerMotivos();
    this.obtenerDrivers();
    this.obtenerOrigenes();
    this.obtenerClasificaciones();
    this.obtenerClinicas();
    this.asignarIDPaciente();
  },
  methods: {
    reiniciarFormulario() {
      this.solicitud = {
        idPaciente: null,
        idClinica: null,
        idOrigen: null,
        calificacion: null,
        especialidad: null,
        idClasificacion: null,
        descripcion: null,
        driver: null,
        tema: null,
        subtema: null,
        tipoQueja: null,
      };
    },
    asignarIDPaciente() {
      this.solicitud.idPaciente = this.idPaciente;
    },
    abrirModalContacto() {
      this.modalContacto = true;
    },
    setearValor(valor) {
      this.contactoSeleccionado = valor;
    },
    obtenerOrigenes() {
      this.garantiaServicio.obtenerOrigenQuejas().then(response => {
        this.origenes = response.data;
      });
    },
    obtenerClinicas() {
      this.catalogoServicio.listaClinicas().then((response) => {
        this.clinicas = response;
      });
    },
    obtenerClasificaciones() {
      let body ={
        "idClasificacion": 4
      }
      this.catalogoServicio.obtenerClasificaciones(body).then((response) => {
        this.clasificaciones = response.data;
      });
    },
    seleccinarPaciente(paciente) {
      this.solicitud.idPaciente = paciente.idPaciente;
      //buscamos los planes del paciente
    },
    getBuscarPacienteServicio(search, loading) {
      loading(true);
      clearTimeout(this.controladorTiempo);
      this.controladorTiempo = setTimeout(() => {
        const params = {
          nombrePaciente: search
        }
        this.$http
            .post(
                this.$api +
                "paciente/perfiles/obtenerpacientes/activos", params)
            .then((response) => {
              if (response.data.data) {
                this.listaBusquedaPaciente = [];
                let resultado = response.data.data;
                resultado.forEach((item, index) => {
                  item.id = index;
                  this.listaBusquedaPaciente.push(item);
                });
                loading(false);
              }
            })
            .catch(function (error) {
              console.error(error);
              loading(false);
              this.$swal({
                icon: "error",
                text: "A ocurrido un error, intentalo más tarde.",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            });
        clearTimeout(this.controladorTiempo);
      }, 1000);
    },
    guardar() {
      this.$v.solicitud.$touch();
      if (this.$v.solicitud.$anyError) {
        return false;
      }
      this.loaderGuardar = true;
      this.garantiaServicio
          .guardarSolicitud(this.solicitud)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Se registro correctamente",
              showConfirmButton: false,
            });
            this.actualizarHistorial = !this.actualizarHistorial;
            this.reiniciarFormulario();
            /* this.vistaFiltrado = true; */
            this.$v.$reset();
            /* window.history.back(); */
            this.tabIndex++
          })
          .finally(() => {
            this.loaderGuardar = false;
          });
    },
    obtenerMotivos() {
      this.garantiaServicio.obtenerMotivos().then((response) => {
        this.tipoQuejas = response.data;
      });
    },
    obtenerDrivers() {
      this.garantiaServicio.obtenerDrivers().then((response) => {
        this.drivers = response.data;
      });
    },
    obtenerTemas() {
      const parametros = {idDriverQueja: this.solicitud.driver}
      this.garantiaServicio
          .obtenerTema(parametros)
          .then((response) => {
            this.temas = response.data;
          });
    },
    obtenerSubTemas() {
      this.garantiaServicio
          .obtenerSubTema(this.solicitud.tema)
          .then((response) => {
            this.subtemas = response.data;
          });
    },

    validateState(name) {
      const {$dirty, $error} = this.$v.solicitud[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.bCardQueja {
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  width: 100%;
  margin-left: 1%;
  margin-right: 3%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}
</style>
